<div class="loadingio-spinner-dual-ring-5lztzerqvhy">
  <div class="ldio-23sgvj19m2h">
    <div></div>
    <div>
      <div></div>
    </div>
  </div>
</div>
